import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/translations';
import * as translationPageActions from '../actions/translations';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import { TranslationService } from '../../api/translation-service';
import * as coreActions from '../actions/core';

const T = Translator.create();
const _logger = Log.create('profile Saga');
const _translationService = new TranslationService();

function* getGlobalizationAction(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const response: Response = yield _translationService.RequestGetGlobalizationListsAsync({
            SearchedText: params.SearchedText,
            IsCustomized: params.IsCustomized,
            Culture: params.Culture,
            Page: params.Page,
            Skip: params.Skip,
            Take: params.Take
        });

        if (response.status !== 200) {
            isError = true;
        }

        const data = yield response.json();

        if (isError) {
            errorList = data;
        } else {
            pageData = data;
        }

        if (!isError) {
            yield put(translationPageActions.SetGlobalizationList(pageData.results, pageData.filters, params.spinnerId, 'set'));

            if (params.callback) {
                params.callback("success");
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* updateGlobalizationAction(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const response: Response = yield _translationService.RequestUpdateGlobalizationAsync({
            GlobalizationId: params.globalizationId,
            GlobalizationKey: params.globalizationKey,
            GlobalizationValue: params.globalizationValue,
            Culture: params.culture
        });

        if (response.status !== 200) {
            isError = true;
        }

        const data = yield response.json();

        if (isError) {
            errorList = data;
        } else {
            pageData = data;
        }

        if (!isError) {
            yield put(translationPageActions.RefereshGlobalizationList(pageData, "update"));
            Notification.setNotification('success', T.t('r_globalization_key_updated_successfully'), 'topRight');
            if (params.callback) {
                params.callback("success");
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* deleteGlobalizationAction(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const response: Response = yield _translationService.RequestDeleteGlobalizationAsync({
            GlobalizationId: params.globalizationId,
            GlobalizationKey: params.globalizationKey,
            Culture: params.culture
        });

        if (response.status !== 200) {
            isError = true;
        }

        const data = yield response.json();

        if (isError) {
            errorList = data;
        } else {
            pageData = data;
        }

        if (!isError) {
            if (params.callback) {
                params.callback("success");
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

export function* watchGetGlobalizationData() {
    yield takeEvery(constants.actions.GET_LIST_GLOBALIZATION, getGlobalizationAction);
    return null;
}

export function* watchUpdateGlobalization() {
    yield takeEvery(constants.actions.UPDATE_GLOBALIZATION, updateGlobalizationAction);
    return null;
}

export function* watchDeleteGlobalization() {
    yield takeEvery(constants.actions.DELETE_GLOBALIZATION, deleteGlobalizationAction);
    return null;
}


export function* TranslationSagas() {
    yield all([
        watchGetGlobalizationData(),
        watchUpdateGlobalization(),
        watchDeleteGlobalization()
    ]);
}
